import { type ITranslationServiceProvider } from '#domain/translation/translation.service.interface';
import ApiClient from '#infra/config/api.client';
import type { TranslationsType } from '#root/domain/translation/translation.schema';

export class TranslationServiceProvider implements ITranslationServiceProvider {
  async getTranslations(language: string): Promise<TranslationsType> {
    const response = await ApiClient.get(`/translations/${language}`);
    return response.data;
  }
}
